import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OperacionProductos = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const isEnglish = location.pathname.startsWith("/en");

    return(
        <section>
            <div className="operacion-productos">
                <div className="container">
                    <img src="../../assets/img/img-home-operacion.webp" alt={t("home.operacion")} title={t("home.operacion")} className="tag"/>
                    <Link to={isEnglish ? "/en/operation" : "/nuestra-operacion"} className="btn">
                        {t("home.operacion")}
                    </Link>  
                </div>
                <div className="container">
                    <img src="../../assets/img/img-home-producto.webp" alt={t("home.productos")} title={t("home.productos")} className="tag"/>
                    <Link to={isEnglish ? "/en/products" : "/productos"} className="btn">
                        {t("home.productos")}
                    </Link>  
                </div>
            </div>
        </section>
    )
}

export default OperacionProductos